import React, { Component } from "react";
import './engagements.css';
import Slider from "react-slick";
import { FormattedMessage } from 'react-intl';

const settings = {
  dots: true,
  infinite: true,
  arrows: false,
  speed: 2500,
  fade: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2500,
  pauseOnHover: false
};

class Engagements extends Component {

  render() {
    return (
      <div>
        <div className="row engagements-row" >
          <img className="engagements-swirl" src="img/engagements/swirl-2.png" alt="About" />
          <div className="col-sm-3 d-none d-sm-block engagements-image-col">
            <img className="engagements-image" src="img/engagements/engagements-1.jpg" alt="Engagements 1" />
          </div>
          <div className="col-sm-3 d-none d-sm-block engagements-image-col">
            <img className="engagements-image" src="img/engagements/engagements-2.jpg" alt="Engagements 2" />
          </div>
          <div className="col-sm-3 d-none d-sm-block engagements-image-col">
            <img className="engagements-image" src="img/engagements/engagements-3.jpg" alt="Engagements 3" />
          </div>
          <div className="col-sm-3 d-none d-sm-block engagements-image-col">
            <img className="engagements-image" src="img/engagements/engagements-4.jpg" alt="Engagements 4" />
          </div>
          <div className="col-sm-3 d-block d-sm-none engagements-slide-col">
            <Slider className="engagement-slider"  {...settings}>
              <div>
            <img className="engagements-image" src="img/engagements/engagements-1.jpg" alt="Engagements 1" />
              </div>
              <div>
            <img className="engagements-image" src="img/engagements/engagements-2.jpg" alt="Engagements 2" />
              </div>
              <div>
            <img className="engagements-image" src="img/engagements/engagements-3.jpg" alt="Engagements 3" />
              </div>
              <div>
            <img className="engagements-image" src="img/engagements/engagements-4.jpg" alt="Engagements 4" />
              </div>
            </Slider>
          </div>

        </div>
        <div className="row" >
          <div className="col-sm-3">
          </div>
          <div className="col-sm-6 engagements-text-col">
            <img className="engagements-image" src="img/engagements/engagementswirl.svg" alt="Engagement swirl" />
            <h1 className="engagements-title">
              <span className="engagements-title-capital"><FormattedMessage id={'engagements.capital'} /></span>
              <span className="engagements-title-text"><FormattedMessage id={'engagements.title'} /></span>
            </h1>
            <h2 className="engagements-subtitle" ><FormattedMessage id={'engagements.question'} /></h2>
            <p className="engagements-text" ><FormattedMessage id={'engagements.text'} /></p>
          </div>
          <div className="col-sm-3">
          </div>
        </div>
      </div>
    );
  }
}

export default Engagements;



// WEBPACK FOOTER //
// ./src/engagements/engagements.js